import React, { useState } from 'react';

type Props ={
  maxStars?: number;
  rating?: number; 
  onRatingChange?: (rating: number) => void; 
}

const Rating: React.FC<Props> = ({ maxStars = 5, rating = 0, onRatingChange }) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);
  const [selectedRating, setSelectedRating] = useState<number>(rating);

  const handleClick = (starIndex: number) => {
    setSelectedRating(starIndex);
    onRatingChange?.(starIndex); 
  };

  const renderStars = () => {
    return Array.from({ length: maxStars }, (_, index) => {
      const starIndex = index + 1;
      const isFilled = starIndex <= (hoveredStar || selectedRating);

      return (
        <span
          key={starIndex}
          style={{ cursor: 'pointer', color: isFilled ? '#FFD700' : '#ccc', fontSize: '35px' }}
          onMouseEnter={() => setHoveredStar(starIndex)}
          onMouseLeave={() => setHoveredStar(null)}
          onClick={() => handleClick(starIndex)}>
          ★
        </span>
      );
    });
  };

  return <div>{renderStars()}</div>;
};

export default Rating;
